import { TimelineZoomLimits } from "../../../constants/zoomRange";
import { calendarSelectors } from "../../definition/calendar";
import { unitScaleForZoomLimit } from "../../definition/calendar/dateFunctions/unitScaleFunctions";

const defaultScrollPositionToTimestamp = (viewsById, timestamp, globalState) => {
  return viewsById.map(v => {
    let unitScale = v.timelineOptions.unitScale;
    if (!unitScale) {
      const zoomFrom = globalState.definitions.timelineViewSettings.zoomFrom;
      const zoomTo = globalState.definitions.timelineViewSettings.zoomTo;
      const preferredZoom = TimelineZoomLimits.Year;
      const scalePreferred = 0.5;
      if (zoomFrom <= preferredZoom && zoomTo >= preferredZoom) {
        unitScale =
          unitScaleForZoomLimit(calendarSelectors.getCalendar(globalState), preferredZoom, true) * scalePreferred;
      } else {
        const minScale = unitScaleForZoomLimit(calendarSelectors.getCalendar(globalState), zoomFrom, true);
        const maxScale = unitScaleForZoomLimit(calendarSelectors.getCalendar(globalState), zoomTo, false);
        unitScale = (minScale + maxScale) / 2;
      }
    }
    // Set the initial scroll so that "now" is at 200px
    const scrollOffset = 200;
    return v.update("timelineOptions", opts =>
      opts.set("unitScale", unitScale).setIn(["scrollPosition", "x"], timestamp / unitScale - scrollOffset)
    );
  });
};

export default defaultScrollPositionToTimestamp;
